import React, { useState, useEffect } from 'react';
import { Container, Box, Typography, TextField, Button, Alert } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import axiosInstance from '../../services/api';

const AdminLogin = () => {
  const navigate = useNavigate();
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');

  // Geçerli token varsa direkt dashboard'a git
  useEffect(() => {
    const token = localStorage.getItem('adminToken');
    if (token) {
      try {
        const payload = JSON.parse(atob(token.split('.')[1]));
        if (!payload.exp || payload.exp * 1000 > Date.now()) {
          navigate('/admin/home', { replace: true });
        } else {
          localStorage.removeItem('adminToken');
        }
      } catch {
        localStorage.removeItem('adminToken');
      }
    }
  }, [navigate]);

  const handleSubmit = async (event) => {
    event.preventDefault();
    const loginData = { username, password };

    try {
      const response = await axiosInstance.post('/auth/login', loginData);
      const token = response.data.token;
      localStorage.setItem('adminToken', token);
      navigate('/admin/home');
    } catch (err) {
      // Hata mesajını response üzerinden almaya çalışıyoruz.
      if (err.response && err.response.data && err.response.data.message) {
        setError(err.response.data.message);
      } else {
        setError('Giriş başarısız.');
      }
    }
  };

  return (
    <Container maxWidth="sm">
      <Box 
        sx={{ 
          mt: 8, 
          p: 4, 
          boxShadow: 3, 
          borderRadius: 2, 
          backgroundColor: 'white' 
        }}
      >
        <Typography variant="h4" sx={{ mb: 3, color: 'primary.main' }} align="center">
          Admin Giriş
        </Typography>
        {error && <Alert severity="error" sx={{ mb: 2 }}>{error}</Alert>}
        <form onSubmit={handleSubmit}>
          <TextField
            fullWidth
            label="Kullanıcı Adı"
            variant="outlined"
            margin="normal"
            value={username}
            onChange={(e) => setUsername(e.target.value)}
          />
          <TextField
            fullWidth
            label="Şifre"
            variant="outlined"
            type="password"
            margin="normal"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
          />
          <Button 
            type="submit" 
            variant="contained" 
            fullWidth 
            sx={{ mt: 2, backgroundColor: 'primary.main' }}
          >
            Giriş Yap
          </Button>
        </form>
      </Box>
    </Container>
  );
};

export default AdminLogin;
